// extracted by mini-css-extract-plugin
export default {"container":"goals-layout_container__mdJD4","content":"goals-layout_content__y8cNa","main":"goals-layout_main__Dys13"};